export const LOCAL_STORAGE_KEYS = {
    TOKEN: "token",
    USER_ID: "user_id",
};
